import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

import styles from '../../styles';
import ForgotSubmitForm from '../../components/forms/user/ForgotSubmitForm';

class ForgotSubmit extends React.Component {
  static validateUsername(username) {
    return (username.length >= 4);
  }

  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'ForgotSubmit';

    this.state = {
      email: '',
    };
    this.retrieveEmail().then((email) => this.setState({ email }));
  }

  retrieveEmail = async () => {
    try {
      const value = await AsyncStorage.getItem('email');
      if (value !== null) {
        // Our data is fetched successfully
        console.log(value);
        return value;
      }
    } catch (error) {
      // Error retrieving data
    }

    return '';
  }

  render() {
    const { history, match: { params: { redirect } } } = this.props;
    const { email } = this.state;

    return (
      <View style={styles.view.headed}>
        <ForgotSubmitForm
          email={email}
          redirect={redirect}
          history={history}
        />
      </View>
    );
  }
}

ForgotSubmit.defaultProps = {
  // match: { params: { redirect: '/' } },
};

ForgotSubmit.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default ForgotSubmit;
